"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponse = exports.createRequest = exports.convertHeaders = exports.TransformResponseBodyToString = exports.TransformBodyToObject = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
// TODO: Check the transformers and reuse the existing ones on the server
const TransformBodyToObject = {
    Object: (baseToConvert) => JSON.parse(baseToConvert),
    JsonObject: (baseToConvert) => JSON.parse(baseToConvert),
    Blob: (baseToConvert) => new Blob([baseToConvert]),
    URLSearchParams: (baseToConvert) => new URLSearchParams(baseToConvert),
    FormData: (baseToConvert) => {
        const jsonFormData = JSON.parse(baseToConvert);
        const formData = new FormData();
        for (const key in jsonFormData) {
            if (Object.prototype.hasOwnProperty.call(jsonFormData, key)) {
                const value = jsonFormData[key];
                if (value instanceof Object) {
                    const value = JSON.stringify(jsonFormData[key]);
                    const fileValue = TransformBodyToObject.File(value);
                    formData.append(key, fileValue, fileValue.name);
                }
                else {
                    formData.append(key, value);
                }
            }
        }
        return formData;
    },
    File: (baseToConvert) => {
        const fileData = JSON.parse(baseToConvert);
        const file = new File([fileData.content], fileData.fileName);
        return file;
    },
};
exports.TransformBodyToObject = TransformBodyToObject;
const TransformResponseBodyToString = {
    [web_ui_framework_1.MediaType.BLOB]: (baseToConvert) => {
        return baseToConvert.text();
    },
    [web_ui_framework_1.MediaType.JSON]: (baseToConvert) => Promise.resolve(JSON.stringify(baseToConvert)),
    [web_ui_framework_1.MediaType.FORMDATA]: async (baseToConvert) => {
        const convertedFormData = {};
        for (const [key, value] of baseToConvert) {
            if (value instanceof Blob) {
                convertedFormData[key] = JSON.parse(await TransformResponseBodyToString[web_ui_framework_1.MediaType.BLOB](value));
            }
            else {
                convertedFormData[key] = value;
            }
        }
        return Promise.resolve(JSON.stringify(convertedFormData));
    },
    [web_ui_framework_1.MediaType.FORMURLENCODED]: (baseToConvert) => Promise.resolve(baseToConvert.toString()),
};
exports.TransformResponseBodyToString = TransformResponseBodyToString;
const convertHeaders = (headers) => {
    return Object.keys(headers).reduce((convertedHeaders, key) => {
        convertedHeaders[key] = headers[key];
        return convertedHeaders;
    }, {});
};
exports.convertHeaders = convertHeaders;
const createResponse = async (eventId, xhrResponse, responseType) => {
    const { data, httpStatus, httpStatusText, ok, responseHeaders, message } = xhrResponse;
    let convertedBody;
    if (responseType) {
        convertedBody = await TransformResponseBodyToString[responseType](data);
    }
    else {
        convertedBody = data; // TODO: check this
    }
    const response = {
        id: eventId,
        body: convertedBody,
        status: httpStatus,
        statusText: httpStatusText,
        ok: ok,
        headers: responseHeaders ? convertHeaders(responseHeaders) : {},
        message,
    };
    if (!response.message) {
        response.message = web_ui_framework_1.XHRMessages.XHR_SERVICE_GENERIC_ERROR;
    }
    return response;
};
exports.createResponse = createResponse;
const createRequest = (request) => {
    const { body, bodyType, headers, method, params, url } = request;
    let convertedBody;
    if (bodyType && body) {
        convertedBody = TransformBodyToObject[bodyType](body);
    }
    return {
        method,
        url,
        body: convertedBody,
        xhrOptions: {
            headers,
            params,
        },
    };
};
exports.createRequest = createRequest;
//# sourceMappingURL=utils.js.map